import EventBus from '../core/EventBus'

export default class CursorTrigger {

    constructor(element, options = {}) {
        this.element = element
        this.options = {
            ...options
        }

        this.isDisabled = false

        this.element.addEventListener('mouseenter', this.handleMouseEnter)
        this.element.addEventListener('mouseleave', this.handleMouseLeave)
        this.element.style.cursor = 'none'
    }

    destroy() {
        this.element.removeEventListener('mouseenter', this.handleMouseEnter)
        this.element.removeEventListener('mouseleave', this.handleMouseLeave)
        this.element.removeAttribute('style')
    }

    handleMouseLeave = () => {
        this.leave()
    }

    handleMouseEnter = () => {
        this.enter()
    }

    leave() {
        if (this.isDisabled) {
            return
        }

        EventBus.emit('cursor:region:leave')
    }

    enter() {
        if (this.isDisabled) {
            return
        }

        EventBus.emit('cursor:region:enter', {...this.options})
    }

    disable() {
        this.leave()
        this.isDisabled = true
    }

    enable() {
        this.isDisabled = false
    }

}
